module.exports = __webpack_public_path__ + "static/media/main idea.36c3cd39.mp3";